import React, { useState } from 'react';
import { MdClose } from 'react-icons/md';

import Subscribe from '../forms/subscribe';
import { Link } from 'gatsby';
//import { StaticImage } from 'gatsby-plugin-image';

interface INavLink {
  name: string;
  href: string;
  current: boolean;
}

const navigation: INavLink[] = [
  //{ name: 'Home', href: '/', current: true },
  { name: 'Artists', href: '/artists', current: false },
  { name: 'Exhibitions', href: '/exhibitions', current: false },
  { name: 'Publications', href: '/publications', current: false },
  { name: 'Press', href: '/press', current: false },
  { name: 'About', href: '/about-us', current: false },
  { name: 'Contact', href: '/contact', current: false }
];

const desktopLinkTextStyle = "text-lg font-light text-neutral-900 leading-none tracking-narrow data-selected:font-normal data-selected:text-neutral-800"
const selectedLinkStyle = "data-selected:underline data-selected:underline-offset-4 data-selected:decoration-neutral-900"
const navIconStyle = "text-3xl"

const navLinkMobileStyle = 'text-md';

export default function Navbar(props: { activeLink: string }) {
  const [open, setOpen] = useState(false);
  const [isSubscribeOpen, setSubscribeOpen] = useState(false);

  return (
    <nav
      // relative makes this the containing block for the mobile menu panel.
      // No overflow-y-auto: it would clip that panel where it hangs below the
      // header. The panel caps its own height instead.
      className={`relative w-full blur-bg`}
      // Required for navbar to be on top of other elements. Live only because
      // the element is now positioned; it also lifts the menu panel above
      // PageNavbar, which follows this nav in document order.
      style={{ zIndex: 30 }}
    >
      <Subscribe isOpen={isSubscribeOpen} setOpen={setSubscribeOpen} />
      <div
        // The open menu panel continues this band and draws the bottom border
        // for both, so the row hides its own — otherwise a rule appears between
        // the masthead and the links. The border stays 2px and only turns
        // transparent: removing it would shrink the header by 2px, which is the
        // layout shift this whole change exists to stop. lg: keeps it visible,
        // where no panel renders.
        className={`flex flex-row w-full border-b-2 ${open ? 'border-b-transparent lg:border-b-neutral-200' : 'border-b-neutral-200'}`}
      >
        {/* The masthead is a link home, so it must say so. It previously took
            its label from navigation[0], which stopped meaning "Home" when that
            entry was commented out — announcing the logo as "Artists" to anyone
            navigating by accessible name. */}
        <Link to={"/"} aria-label="Kumar Gallery, home">
          <div 
            // flex-col creates rows of elements
            // flex-shrink shrinks the div horizontally to give space to navigation links
            // justify-center centers the text vertically
            className="flex flex-col flex-shrink justify-center h-24 text-left pl-2"
            id="navLogoDiv"
          >
            <div className="kumar">
              Kumar
            </div>
            <div className="gallery -mt-1">
              Gallery 
              <span className="estd">&nbsp; Estd. 1955</span>
            </div>
          </div>
        </Link>
        <div
          // flex-grow expands the div to take up remaining horizontal space
          // justify-end displays the navigation links from the right
          // items-center centers the text vertically
          // height determined by prior div
          className="flex flex-grow items-center justify-end"
        >
          <div 
            // hidden keeps the Desktop links hidden by default
            // lg:flex makes the links visible on large screens as a flex container
            // flex-wrap wraps the links to the next line on large screens if needed
            // space-x-5 adds space between the links
            className="hidden lg:flex flex-wrap space-x-5 pr-4"
          >
            {navigation.map((link, i) => {
              return (
                <Link
                  to={link.href}
                  key={`link-0-${i}`}
                  data-ui={props.activeLink === link.name && "selected"}
                  className={selectedLinkStyle}
                >
                  <span 
                    className={desktopLinkTextStyle}
                    data-ui={props.activeLink === link.name && "selected"}
                  >
                  {link.name}</span>
                </Link>
              );
            })}
            <div
              // items-center ensures the text is vertically centered
              className={`${desktopLinkTextStyle} flex items-center cursor-pointer text-rose-600 font-bold`}
              onClick={() => {
                setSubscribeOpen(true);
              }}
            >
              Subscribe
            </div>
          </div>
          <div 
            // lg:hidden makes the div invisible on small screens
            // h-24 matches the masthead, so opening the menu cannot change it
            className="lg:hidden flex justify-end items-center h-24 pr-4"
          >
            <span className='sr-only'>Open main menu</span>
            {open ? (
              <MdClose
                className={`${navIconStyle}`}
                aria-hidden='true'
                onClick={() => setOpen(false)}
              />
            ) : (
              <div 
                onClick={() => setOpen(true)}>
                  MENU
              </div>
            )}
          </div>
        </div>
      </div>
      {/* The open menu overlays the page instead of sitting in the header's
          flow. In flow it grew the sticky header, which pushed the whole page
          body down the moment the menu opened. absolute + top-full hangs it off
          the bottom edge of a header whose height never changes. */}
      {open && (
        <div
          // left-0 right-0 keeps the full-width band of the closed header,
          // with the links right-aligned inside it, exactly as before
          // Translucent like the header, but denser — in flow the menu had
          // empty layout space behind it, where an overlay has the page, and
          // artwork read straight through blur-bg's 70% white. Spelled out
          // rather than blur-bg + overrides: blur-bg is emitted after the
          // bg-opacity/backdrop-blur utilities, so it would win on order.
          // max-h/overflow-y-auto: the panel scrolls itself on short screens
          // (a phone in landscape). 98px is this header: h-24 plus its 2px border.
          // dvh, not vh, so a mobile browser's toolbars are excluded
          className="lg:hidden absolute left-0 right-0 top-full flex flex-col items-end
            bg-white/90 backdrop-blur-md border-b-2 border-neutral-200
            pr-6 pt-1 pb-2 max-h-[calc(100dvh_-_98px)] overflow-y-auto"
        >
          {navigation.map((link, i) => {
            return (
              <div
                // justify-end displays the text starting from the right
                className={`flex justify-end w-full py-2`} 
                key={`link-1-${i}`}
              >
                  <a
                    href={link.href}
                    data-selected={props.activeLink === link.name}
                    className={navLinkMobileStyle}
                  >
                    {link.name}
                  </a>
              </div>
            );
          })}
          <div
            className={`${navLinkMobileStyle} cursor-pointer py-2 text-rose-600`}
            onClick={() => {
              setSubscribeOpen(true);
            }}
          >
            Subscribe
          </div>
        </div>
      )}
    </nav>
  );
}


{/**
                <MdMenu
                  className={`${navIcon}`}
                  aria-hidden='true'
                  onClick={() => setOpen(true)}
                /> */}


{/* 
  useEffect(() => {
    // Check if modal has been shown before
    const modalShown = localStorage.getItem("modalShown");
    if (modalShown==="false") {
      localStorage.setItem("modalShown", "true"); // Set flag in localStorage
      setEnquireOpen(true); // Open modal if not shown before
    }
  }, []);*/}